import {
  ChecklistRecord,
  ParteAControlli,
  ParteBControlli,
  ParteCControlli,
  EsitoControllo,
  ChecklistType
} from '../types/datamodel';

// ==================== FORMULE PARTE A ====================

export function calcolaEsitoA1(a1?: ParteAControlli['a1']): EsitoControllo {
  if (!a1) return '';
  if (!a1.correttoAddebito) return '';
  return a1.correttoAddebito === 'Si' ? 'OK' : 'KO';
}

export function calcolaEsitoA2(a2?: ParteAControlli['a2']): EsitoControllo {
  if (!a2) return '';
  if (!a2.attestazioneConsegnaMUP) return '';
  return a2.attestazioneConsegnaMUP === 'Si' ? 'OK' : 'KO';
}

export function calcolaEsitoA3(
  a3?: ParteAControlli['a3'],
  tipologiaOperazione?: string
): EsitoControllo {
  if (!a3) return '';
  if (!a3.presenzaPropostaContratto) return '';

  const { presenzaPropostaContratto, presenzaFirmaProposta } = a3;

  // Nuova emissione
  if (tipologiaOperazione === 'Nuova emissione') {
    if (presenzaPropostaContratto === 'si' && presenzaFirmaProposta === 'Si') {
      return 'OK';
    }
    return 'KO';
  }

  // Versamenti aggiuntivi
  if (tipologiaOperazione === 'Versamenti aggiuntivi') {
    if (
      presenzaPropostaContratto === 'si' &&
      presenzaFirmaProposta === 'Si' &&
      a3.presenzaRichiestaVariazioneVers === 'si' &&
      a3.presenzaFirmaRichiestaVers === 'Si'
    ) {
      return 'OK';
    }
    return 'KO';
  }

  // Riscatti/liquidazioni
  if (tipologiaOperazione === 'Riscatti/liquidazioni') {
    if (
      presenzaPropostaContratto === 'si' &&
      presenzaFirmaProposta === 'Si' &&
      a3.presenzaRichiestaPrestazione === 'Si' &&
      a3.presenzaFirmaPrestazione === 'Si'
    ) {
      return 'OK';
    }
    return 'KO';
  }

  // Variazione contraente
  if (tipologiaOperazione === 'Variazione contraente') {
    if (
      presenzaPropostaContratto === 'si' &&
      presenzaFirmaProposta === 'Si' &&
      a3.presenzaRichiestaVariazioneCont === 'Si' &&
      a3.presenzaFirmaVariazioneCont === 'Si'
    ) {
      return 'OK';
    }
    return 'KO';
  }

  // Quietanzamento o Rimborso
  if (tipologiaOperazione === 'Quietanzamento' || tipologiaOperazione === 'Rimborso premio non goduto') {
    if (presenzaPropostaContratto === 'si' && presenzaFirmaProposta === 'Si') {
      return 'OK';
    }
    return 'KO';
  }

  return '';
}

export function calcolaEsitoA4(a4?: ParteAControlli['a4']): EsitoControllo {
  if (!a4) return '';
  if (!a4.presenzaQuestionario) return '';
  if (a4.presenzaQuestionario === 'si' && a4.presenzaFirmaQuestionario === 'Si') {
    return 'OK';
  }
  return 'KO';
}

export function calcolaEsitoA5(a5?: ParteAControlli['a5']): EsitoControllo {
  if (!a5) return '';
  if (!a5.materialePersonalizzato) return '';
  if (a5.materialePersonalizzato === 'Autorizzato' || a5.materialePersonalizzato === 'n/a') {
    return 'OK';
  }
  return 'KO';
}

export function calcolaEsitoA6(a6?: ParteAControlli['a6']): EsitoControllo {
  if (!a6) return '';
  if (!a6.aggiornamentoSetInformativo) return '';
  if (a6.aggiornamentoSetInformativo !== 'No' || a6.presenzaSetSito !== 'No') {
    return 'OK';
  }
  return 'KO';
}

// ==================== FORMULE PARTE B ====================

export function calcolaEsitoB1(b1?: ParteBControlli['b1']): EsitoControllo {
  if (!b1) return '';
  if (!b1.documentiIdentificazione) return '';
  return b1.documentiIdentificazione === 'Si' ? 'OK' : 'KO';
}

export function calcolaEsitoB2(b2?: ParteBControlli['b2']): EsitoControllo {
  if (!b2) return '';
  if (!b2.qAdv) return '';
  if (b2.qAdv === 'si' && b2.presenzaFirmaQAdv === 'Si') {
    return 'OK';
  }
  return 'KO';
}

// ==================== FORMULE PARTE C ====================

export function calcolaEsitoC1(c1?: ParteCControlli['c1']): EsitoControllo {
  if (!c1) return '';
  if (!c1.presenzaFirmaPrivacy) return '';
  return c1.presenzaFirmaPrivacy === 'Si' ? 'OK' : 'KO';
}

export function calcolaEsitoC2(c2?: ParteCControlli['c2']): EsitoControllo {
  if (!c2) return '';
  if (!c2.formazioneObbligatoria) return '';
  return c2.formazioneObbligatoria === 'Si' ? 'OK' : 'KO';
}

export function calcolaEsitoC3(c3?: ParteCControlli['c3']): EsitoControllo {
  // Guard against undefined c3
  if (!c3) return '';
  if (!c3.collocatoreAbilitato) return '';
  if (c3.collocatoreAbilitato === 'no') {
    return 'OK';
  }
  if (c3.collocatoreAbilitato === 'si' && c3.verificaIscrizioneRUI === 'Si') {
    return 'OK';
  }
  return 'KO';
}

export function calcolaEsitoC4(c4?: ParteCControlli['c4']): EsitoControllo {
  if (!c4) return '';
  if (!c4.presenzaModuloFATCA) return '';
  if (c4.presenzaModuloFATCA === 'no') {
    return 'OK';
  }
  if (c4.presenzaModuloFATCA === 'si' && c4.presenzaFirmaFATCA === 'si') {
    return 'OK';
  }
  return 'KO';
}

// ==================== CALCOLO AUTOMATICO COMPLETO ====================

export function calcolaTuttiEsitiRecord(
  record: ChecklistRecord,
  checklistType: ChecklistType
): ChecklistRecord {
  const updatedRecord = { ...record };

  // Ensure parteA exists
  const parteA = updatedRecord.parteA || {} as ParteAControlli;

  // Parte A
  updatedRecord.parteA = {
    ...parteA,
    a1: parteA.a1 ? { ...parteA.a1, esito: calcolaEsitoA1(parteA.a1) } : parteA.a1,
    a2: parteA.a2 ? { ...parteA.a2, esito: calcolaEsitoA2(parteA.a2) } : parteA.a2,
    a3: parteA.a3 ? {
      ...parteA.a3,
      esito: calcolaEsitoA3(parteA.a3, updatedRecord.infoPrincipali?.tipologiaOperazione)
    } : parteA.a3,
    a5: parteA.a5 ? { ...parteA.a5, esito: calcolaEsitoA5(parteA.a5) } : parteA.a5
  };

  if (parteA.a4) {
    updatedRecord.parteA.a4 = {
      ...parteA.a4,
      esito: calcolaEsitoA4(parteA.a4)
    };
  }

  if (parteA.a6) {
    updatedRecord.parteA.a6 = {
      ...parteA.a6,
      esito: calcolaEsitoA6(parteA.a6)
    };
  }

  // Ensure parteB exists
  const parteB = updatedRecord.parteB || {} as ParteBControlli;

  // Parte B
  updatedRecord.parteB = {
    ...parteB,
    b1: parteB.b1 ? { ...parteB.b1, esito: calcolaEsitoB1(parteB.b1) } : parteB.b1,
    b2: parteB.b2 ? { ...parteB.b2, esito: calcolaEsitoB2(parteB.b2) } : parteB.b2
  };

  // Ensure parteC exists
  const parteC = updatedRecord.parteC || {} as ParteCControlli;

  // Parte C
  updatedRecord.parteC = {
    ...parteC,
    c1: parteC.c1 ? { ...parteC.c1, esito: calcolaEsitoC1(parteC.c1) } : parteC.c1,
    c2: parteC.c2 ? { ...parteC.c2, esito: calcolaEsitoC2(parteC.c2) } : parteC.c2,
    c3: parteC.c3 ? { ...parteC.c3, esito: calcolaEsitoC3(parteC.c3) } : parteC.c3
  };

  if (parteC.c4) {
    updatedRecord.parteC.c4 = {
      ...parteC.c4,
      esito: calcolaEsitoC4(parteC.c4)
    };
  }

  // Update timestamp
  updatedRecord.updatedAt = new Date();

  return updatedRecord;
}
